import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './About.module.css';

const About = () => {
  const { t } = useTranslation();
  const credentialsKeys = [0, 1, 2, 3, 4, 5];
  const credentials = credentialsKeys.map(i => t(`about.credentials.${i}`));
  return (
    <section id="about" className={styles.section}>
      <div className={styles.left}>
        <p className={styles.label}>{t('about.leftLabel')}</p>
        <h2 className={styles.title}>{t('about.leftTitle')}</h2>
        <blockquote className={styles.quote}>
          "{t('about.quote')}"
        </blockquote>
        <div className={styles.credentials}>
          {credentials.map((c) => (
            <div key={c} className={styles.credItem}>
              <div className={styles.dot}></div>
              <p className={styles.credText}>{c}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.right}>
        <p className={styles.label}>{t('about.rightLabel')}</p>
        <h2 className={styles.title}>{t('about.rightTitle')}</h2>
        <p className={styles.desc}>
          {t('about.desc')}
        </p>
        <p className={styles.desc2}>
          {t('about.desc2')}
        </p>
        <div className={styles.badges}>
          <div className={styles.badge}>🕐 {t('about.hours')}</div>
          <div className={styles.badge}>📞 {t('about.emergency')}</div>
          <div className={styles.badge}>🌐 {t('about.languages')}</div>
        </div>
      </div>
    </section>
  );
};

export default About;
